import type { IconName } from '@frontend/web-react/components/Primitives/Icon/helpers';
import type { ButtonVariant } from '../Primitives';
import { Button } from '../Primitives';

type SSOProvider = 'apple' | 'google';

type SSOButtonProps = {
  disabled?: boolean;
  isLoading?: boolean;
  label: string;
  onClick: () => void;
  provider: SSOProvider;
};

const providerConfig: Record<SSOProvider, { buttonStyle: ButtonVariant; iconName: IconName }> = {
  apple: {
    buttonStyle: 'secondary',
    iconName: 'AppleLogo',
  },
  google: {
    buttonStyle: 'primary',
    iconName: 'GoogleLogo',
  },
};

export const SSOButton = ({ disabled, isLoading, label, onClick, provider }: SSOButtonProps) => {
  const config = providerConfig[provider];

  return (
    <Button
      accessibilityLabel={label}
      disabled={disabled || isLoading}
      fullWidth
      isLoading={isLoading}
      leftIconName={config.iconName}
      onClick={onClick}
      type="button"
      variant={config.buttonStyle}
    >
      {label}
    </Button>
  );
};
